import { IFileData } from "../CreateFeeSchedule";

export const generateRulesetList = ({
  providers,
  payers,
  data,
  manual,
}: {
  providers: { name: string; value: string }[];
  payers: { name: string; value: number }[];
  data: IFileData[];
  manual: boolean;
}) => {
  const result = [] as any[];
  const providerIds = providers.map((provider) => provider.value);
  const payerIds = payers.map((payer) => payer.value);

  providerIds.forEach((providerId) => {
    payerIds.forEach((payerId) => {
      const newObj = {
        providerId,
        payerId,
        data,
        manual,
      };
      result.push(newObj);
    });
  });
  return result;
};
